<!-- 用户订单 -->
<template>
  <div class="ucenter">
    <!-- 订单退款理由和客服反馈弹窗 -->
    <el-dialog title="退款理由" :visible.sync="dialogReasonVisible">
      <el-form :model="form">
        <el-form-item label="申请退款原因" label-width="120">
          <el-input v-model.trim="form.reason" placeholder="请输入申请退款原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogReasonVisible = false">取 消</el-button>
        <el-button type="primary" @click="refundOrder">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 订单退货单号弹窗 -->
    <el-dialog title="退单申请" :visible.sync="dialogFormVisible" custom-class="refundInfoDialog">
      <el-row id="refund-dialog">
        <el-col :span="12" style="font-size: 16px; color: #3b3e44">退货地址</el-col>
        <el-col :span="12" style="font-size: 12px; text-align: right; color: #757479">
          <i class="el-icon-warning"
            style="color: rgb(246, 193, 87); font-size: 14px; margin-right: 5px"></i>拒收到付件，严禁在包裹中夹带现金！</el-col>
      </el-row>
      <el-row style="margin: 10px 0 20px 0">
        <el-col :span="12">地址：<span style="color: #ff6700">江苏省扬州市邗江区荷叶南苑25幢9号</span></el-col>
        <el-col :span="5">联系人：<span style="color: #ff6700">退货组</span></el-col>
        <el-col :span="5">联系电话：<span style="color: #ff6700">15861388608</span></el-col>
        <el-col :span="2">复制</el-col>
      </el-row>
      <el-form :model="form" :inline="true">
        <el-form-item label="快递" label-width="120">
          <el-select v-model.trim="form.express_company" placeholder="请选择快递" style="min-width: 300px">
            <el-option label="申通" value="申通"></el-option>
            <el-option label="圆通" value="圆通"></el-option>
            <el-option label="中通" value="中通"></el-option>
            <el-option label="韵达" value="韵达"></el-option>
            <el-option label="极兔" value="极兔"></el-option>
            <el-option label="邮政" value="邮政"></el-option>
            <el-option label="顺丰" value="顺丰"></el-option>
            <el-option label="丰网" value="丰网"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退单运单号" label-width="120">
          <el-input v-model.trim="form.express_no" placeholder="请输入用户的退单的运单号" style="min-width: 300px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="completeRefundExpressInfo">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 物流查询弹窗 -->
    <el-dialog title="物流查询" :visible.sync="dialogShipVisable">
      <el-timeline :reverse="false">
        <el-timeline-item v-for="(item, index) in shipData" :key="index" :timestamp="item.time"
          :color="index > 0 ? '' : '#0bbd87'">
          {{ item.context }}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>

    <!-- 订单列表 -->
    <el-row :gutter="20">
      <el-col :span="5" class="ucenter-sider">
        <div class="sidebar-container">
          <div class="sidebar-title">会员中心</div>
          <el-collapse v-model="activeName" accordion>
            <el-collapse-item name="1">
              <template slot="title">
                <div class="collapse-item__title">
                  <i class="el-icon-shopping-cart-2" style="margin-right: 8px; color: #ff6b6b;"></i>
                  交易中心
                </div>
              </template>
              <ul class="collapse-item__ul">
                <li v-for="(item, k) in tradeMenu" :key="k" @click="changeUrl(item)"
                  :class="{ 'active': item.id === activeId }">
                  {{ item.title }}
                </li>
              </ul>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-col>
      <el-col :span="19" class="ucenter-content">
        <!-- 我的订单 -->
        <div class="content-container">
          <!-- 筛选框 -->
          <div class="filter-section">
            <div class="section-header">
              <div class="section-title">
                <i class="el-icon-search" style="color: #ff6b6b; font-size: 20px;"></i>
                <span style="margin-left: 8px;">订单筛选</span>
              </div>
            </div>
            <el-form ref="form" :model="query" label-width="90px" class="filter-form">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="起止日期">
                    <el-date-picker type="date" placeholder="起始日期" v-model="query.start" value-format="yyyy-MM-dd"
                      style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="至">
                    <el-date-picker type="date" placeholder="截止日期" v-model="query.end" value-format="yyyy-MM-dd"
                      style="width: 100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="订单状态">
                    <el-select v-model="query.status_code" placeholder="请选择订单状态" style="width: 100%;">
                      <el-option v-for="(op, k) in orderStatusOptions" :key="k" :label="op.label" :value="op.value">{{
                        op.label }}</el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="订单号">
                    <el-input v-model="query.order_no" placeholder="请输入订单号"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="快递单号">
                    <el-input v-model="query.express_no" placeholder="请输入快递单号"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="收件人">
                    <el-input v-model="query.name" placeholder="请输入收件人"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="手机号码">
                    <el-input v-model="query.mobile" placeholder="请输入手机号码"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="订单备注">
                    <el-input v-model="query.remark" placeholder="请输入订单备注"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item>
                    <el-button type="primary" @click="orderQuery" class="search-button">
                      <i class="el-icon-search"></i> 查询订单
                    </el-button>
                    <el-button type="success" @click="orderExport" class="export-button">
                      <i class="el-icon-download"></i> 导出订单
                    </el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <!-- 快捷查询 -->
          <div class="quick-filter-section">
            <el-tabs v-model="query.status_code" type="card" @tab-click="quickQuery" class="custom-tabs">
              <el-tab-pane v-for="(op, k) in orderStatusOptions" :key="k" :label="op.label"
                :name="op.value"></el-tab-pane>
            </el-tabs>
          </div>

          <!-- 订单列表区域 -->
          <div class="order-list-section">
            <div class="section-header">
              <div class="section-title">
                <i class="el-icon-s-order" style="color: #ff6b6b; font-size: 20px;"></i>
                <span style="margin-left: 8px;">订单列表</span>
              </div>
              <div class="batch-actions">
                <el-checkbox v-model="checked">全选</el-checkbox>
                <el-button type="primary" size="small" @click="batchPay" class="batch-btn">
                  <i class="el-icon-wallet"></i> 批量付款
                </el-button>
                <el-button type="danger" size="small" @click="batchCancel" class="batch-btn">
                  <i class="el-icon-close"></i> 批量取消
                </el-button>
              </div>
            </div>
            <!-- 表格数据 -->
            <el-row v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)">
              <el-row v-for="(item, index) in orders" :key="index" style="width: 100%">
                <el-col :span="24">
                  <el-row class="order-info">
                    <el-col :span="12">
                      <div class="order-info-main">
                        <span><el-checkbox v-model="checked"></el-checkbox></span>
                        <span style="margin: 0 10px 0 10px">代发订单号: {{ item.order_no }}</span>
                        <span style="margin: 0 10px 0 10px;cursor: pointer" @click="copyToClipboard(item.order_no)"><i
                            class="el-icon-document-copy" /></span>
                        <span style="margin: 0 10px 0 10px">下单时间: {{ item.created_at }}</span>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="order-info-user">
                        <span style="margin: 0 20px 0 20px">收件人: {{ item.name }}</span>
                        <span>手机: {{ item.mobile }}</span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="24">
                  <el-table :data="item.goods_list" style="width: 100%;" align="center" :span-method="tableRowSpan"
                    border class="order-table">
                    <el-table-column label="代发订单号" min-width="200" align="center">
                      <template slot-scope="scope">
                        <div class="goods-cell">
                          <div class="goods-image">
                            <router-link :to="{
                              path: '/detail',
                              query: { id: scope.row.goods_id },
                            }">
                              <el-image :src="scope.row.thumbnail" />
                            </router-link>
                          </div>
                          <div class="goods-info">
                            <div class="goods-info-name">
                              <el-tooltip :content="scope.row.sname + '   ' + scope.row.goods_name
                                " placement="top">
                                <span>{{
                                  scope.row.goods_name + " " + scope.row.sname
                                  }}</span>
                              </el-tooltip>
                            </div>
                            <div class="goods-info-no">
                              <span>货号: </span>{{ scope.row.goods_sn }}
                            </div>
                            <div class="goods-info-price">
                              <span>单价: </span>￥{{ scope.row.price }}
                            </div>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="规格" min-width="120" align="center">
                      <template slot-scope="scope">
                        <div class="goods-spec">
                          {{ scope.row.size + "," + scope.row.color }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="购/配/发" min-width="120" align="center">
                      <template slot-scope="scope">
                        <div class="goods-spec">
                          {{ scope.row.goods_num }} /
                          {{
                            scope.row.done_status > 0 ? scope.row.goods_num : 0
                          }}
                          / -
                          {{
                            scope.row.goods_remark
                              ? "(" + scope.row.goods_remark + ")"
                              : ""
                          }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="总金额" min-width="140" align="center">
                      <template slot-scope="scope">
                        <div class="order-total-money">
                          <div>￥{{ scope.row.totalMoney }}</div>
                          <div>(运费：￥{{ scope.row.express_fee }})</div>
                          <div>(金币：-￥{{ scope.row.gold }})</div>
                          <div>(实付：￥{{ scope.row.payTotal }})</div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="订单状态" min-width="100" align="center">
                      <template slot-scope="scope">
                        <div class="order-status">
                          <span class="status-text">
                            {{ orderStatusText(scope.row.order_no) }}
                          </span>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="100" align="center">
                      <template slot-scope="scope">
                        <div class="action-links">
                          <el-link type="primary" @click="cancleOrder(scope.row.order_no)"
                            v-if="scope.row.pay_status <= 0">取消订单</el-link>
                          <el-link type="primary" @click="payOrder(scope.row)"
                            v-if="scope.row.pay_status <= 0">立即支付</el-link>
                          <!-- 申请退款/退货退款 -->
                          <el-link type="primary" :disabled="scope.row.refund_status ? true : false"
                            @click="openRefundDialog(scope.row)" v-if="
                              scope.row.refund_service_status < 3 &&
                              scope.row.pay_status == 1 &&
                              scope.row.refund_status == 0
                            ">{{
                            scope.row.express_no ? "申请退货退款" : "申请退款"
                            }}</el-link>
                          <!-- 补充快递和退单号 -->
                          <el-link type="primary" v-if="
                            scope.row.refund_service_status == 3 &&
                            scope.row.refund_status == 1
                          " @click="openRefundInfoDialog(scope.row.order_no)">补充退单号</el-link>
                          <!-- 查看物流 -->
                          <el-link type="primary" v-if="scope.row.express_status" @click="
                            getExpressInfo(
                              scope.row.express_company,
                              scope.row.express_no,
                            )
                            ">查看物流</el-link>
                          <!-- 订单详情 -->
                          <el-link type="primary" @click="getOrderInfo(scope.row)">订单详情</el-link>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
                <el-col :span="24">
                  <el-row class="order-express">
                    <el-col :span="6" style="padding-left: 20px">
                      <div>快递：{{ item.express_company }}</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="goods-num">共{{ item | orderGoodsNum }}件</div>
                    </el-col>
                    <el-col :span="12">
                      <div style="padding-left: 20px">
                        <span>快递单号: {{ item.express_no }}</span>
                        <span style="margin-left: 20px;cursor: pointer" @click="copyToClipboard(item.express_no)"><i
                            class="el-icon-document-copy" /></span>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-row>
            <!-- 底部分页 -->
            <div class="pagination-container">
              <el-pagination background layout="prev, pager, next, total" :page-size="query.pageSize"
                :total="totalCount" @current-change="currentChange"></el-pagination>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUcenterCollapseItems } from "@/util/common";

export default {
  name: "Order",
  data() {
    return {
      // 筛选框打开
      activeQuery: ["1"],
      // 左侧菜单选中
      activeName: "1",
      activeId: 1,
      // 订单状态编码格式 pay_status + express_status + done_status + refund_status + finish_status
      orderStatusOptions: [
        { label: "全部订单", value: "-" },
        { label: "等待支付", value: "00000" },
        { label: "等待发货", value: "10000" },
        { label: "等待配货", value: "11000" },
        { label: "配货完成", value: "11100" },
        { label: "申请退款", value: "1--10" },
        { label: "完结订单", value: "1---1" },
      ],
      tradeMenu: [],
      dialogReasonVisible: false,
      dialogFormVisible: false,
      dialogShipVisable: false,
      loading: true,
      orders: [],
      originalOrders: [],
      total: [],
      shipData: [],
      totalCount: 0,
      currentPage: 1, //当前页码
      checked: false,
      form: {
        order_express_no: "", // 订单运单号
        reason: "",
        order_no: "",
        express_company: "", // 退单快递
        express_no: "", // 退单运单号
      },
      query: {
        page: 1,
        pageSize: 10,
        uid: 0,
        start: "",
        end: "",
        order_no: "",
        express_no: "",
        status_code: "-",
        name: "",
        mobile: "",
        remark: "",
      },
    };
  },
  filters: {
    /**
     * 订单商品总数
     * @param {*} item
     */
    orderGoodsNum(item) {
      let num = 0;
      item.goods_list.map((item) => {
        num += item.goods_num;
      });
      return num;
    }
  },
  created() {
    this.tradeMenu = getUcenterCollapseItems();
    this.query.uid = this.$store.getters.getUser.id;
    this.getOrders();
  },
  methods: {
    /**
     * 切换链接
     * @param {*} item
     */
    changeUrl(item) {
      if (item.url) {
        this.activeId = item.id;
        this.$router.push(item.url);
      }
    },
    /**
     * 订单检索
     */
    orderQuery() {
      this.query.page = 1;
      this.loading = true;
      this.getOrders();
    },
    /**
     * 快捷查询
     */
    quickQuery() {
      this.query.page = 1;
      this.loading = true;
      this.getOrders();
    },
    /**
     * 订单导出
     */
    orderExport() {
      if (!this.$store.getters.getUser.id) {
        this.notifyError("请登录!");
      } else {
        const queryString = new URLSearchParams(this.query).toString();
        let url =
          "https://apimanager.toysmodel.cn/api/rbh/order/export?" + queryString;
        window.open(url);
        this.notifySucceed("导出中，请稍候!");
      }
    },
    /**
     * 获取订单数据
     */
    async getOrders() {
      const { data } = await this.$axios.post(
        this.$newApi + "/api/rbh/order/user",
        this.query,
      );
      this.originalOrders = data.data.list;
      const orders = this.originalOrders
      for (let i = 0; i < orders.length; i++) {
        const orderItem = orders[i];
        const { goods_list, ...orderItemInfo } = orderItem;
        const rowspan = goods_list.length;
        orderItem.goods_list = goods_list.map((goodsItem, index) => {
          const goods = { ...orderItemInfo, ...goodsItem }
          goods.rowspan = rowspan;
          goods.goodsIndex = index; // 添加商品在列表中的索引
          goods.totalMoney = parseFloat(
            parseFloat(goods.daifa_fee) +
            parseFloat(goods.check_fee) +
            parseFloat(goods.package_fee) +
            parseFloat(goods.brand_fee) +
            parseFloat(goods.wishcard_fee) +
            parseFloat(goods.express_fee) +
            parseFloat(goods.goods_total)
          ).toFixed(2);
          goods.payTotal = parseFloat(
            parseFloat(goods.totalMoney) - parseFloat(goods.gold),
          ).toFixed(2);
          return goods;
        });
        orders[i] = orderItem;
      }
      this.orders = orders;
      this.totalCount = data.data.totalCount;
      this.loading = false;
    },
     /**
    * 订单状态
    * @param {*} order_no
    */
    orderStatusText(order_no) {
      const item = this.originalOrders.find(item => item.order_no === order_no)
      if (!item) return ''
      if (item.pay_status < 1) {
        return "等待支付";
      }
      if (item.refund_status > 0) {
        if (item.refund_service_status == 5) {
          return "退款完成";
        }
        if (item.refund_service_status == 6) {
          return "拒绝退款";
        }
        return item.goods_list.filter(item => item.refund == 1).length > 0 ? "部分退款" : "退款审核中";
      }
      if (item.express_status < 1) {
        return "等待发货";
      }
      if (item.done_status < 1) {
        return "等待配货";
      }
      if (item.finish_status > 0) {
        return "订单完结";
      } else {
        return "配货完成";
      }
    },
    /**
     * 表格行合并
     * @param param0 
     */
    tableRowSpan({ row, columnIndex }) {
      // 只有每个订单的第一个商品显示合并的单元格（总金额、状态、操作列）
      if (columnIndex >= 3) {
        if (row.goodsIndex === 0) {
          return {
            rowspan: row.rowspan,
            colspan: 1,
          };
        } else {
          // 其他商品行不显示这些单元格（被合并了）
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1,
        };
      }
    },
    /**
     * 复制到剪贴板
     * @param {*} text
     */
    copyToClipboard(text) {
      this.$copyText(text).then(() => {
        this.notifySucceed("复制成功!");
      });
    },
    /**
     * 变更页码
     * @param {*} currentPage
     */
    currentChange(currentPage) {
      this.loading = true;
      this.query.page = currentPage;
      this.getOrders();
    },
    /**
     * 取消订单
     * @param {*} order_no
     */
    async cancleOrder(order_no) {
      await this.$axios.get(
        this.$apiBaseUrl + "/api/62511460d3358?order_no=" + order_no,
      );
      this.notifySucceed("订单取消成功!");
      this.$router.go(0);
    },

    /**
     * 订单详情
     * @param {*} order
     */
    getOrderInfo(order) {
      const routerUrl = this.$router.resolve({
        path: "/orderInfo",
        query: { order_no: order.order_no },
      });
      window.open(routerUrl.href, "_blank");
    },
    /**
     * 批量付款
     */
    batchPay() {
      this.notifySucceed("开发中!");
    },
    /**
     * 批量取消
     */
    batchCancel() {
      this.notifySucceed("开发中!");
    },
    /**
     * 订单支付跳转
     * @param {*} order
     */
    async payOrder(order) {
      const payTotal = parseFloat(
        parseFloat(order.daifa_fee) +
        parseFloat(order.check_fee) +
        parseFloat(order.package_fee) +
        parseFloat(order.brand_fee) +
        parseFloat(order.wishcard_fee) +
        parseFloat(order.express_fee) +
        parseFloat(order.goods_total) -
        parseFloat(order.gold),
      ).toFixed(2);
      if (parseFloat(payTotal) === 0.0) {
        // 全金币支付
        let response = await this.$axios.get(
          this.$apiBaseUrl + "/api/6329752b4c446?order_no=" + order.order_no,
        );
        if (response.data.code === 1) {
          this.notifySucceed("支付成功，即将跳转我的订单页面!");
        } else {
          this.notifyError(response.data.msg);
        }
      } else {
        window.location.href =
          "https://apicenter.toysmodel.cn/api/6246c2e832768?web=1&order_no=" +
          order.order_no;
      }
    },
    /**
     * 打开退单弹窗
     * @param {*} order
     */
    openRefundDialog(order) {
      this.form.order_no = order.order_no;
      this.form.order_express_no = order.express_no;
      this.dialogReasonVisible = true;
    },
    /**
     * 申请退单
     */
    async refundOrder() {
      await this.$axios.post(this.$newApi + "/api/rbh/order/refund", {
        uid: this.query.uid,
        order_no: this.form.order_no,
        reason: this.form.reason,
      });
      this.notifySucceed(
        this.form.order_express_no
          ? "您的退货退款申请已发送给代发商家，请耐心等待审核!"
          : "您的退款申请已发送给代发商家，请耐心等待审核!",
      );
      this.dialogReasonVisible = false;
    },
    /**
     * 打开退单号回填表单
     * @param {*} order_no
     */
    openRefundInfoDialog(order_no) {
      this.form.order_no = order_no;
      this.dialogFormVisible = true;
    },
    /**
     * 补充退单号
     * @param {*} order_no
     */
    async completeRefundExpressInfo() {
      await this.$axios.get(
        this.$newApi +
        "/api/rbh/order/setRefundExpress?order_no=" +
        this.form.order_no +
        "&express_no=" +
        this.form.express_no,
      );
      this.dialogFormVisible = false;
      this.notifySucceed("商家已收到您的退单号，请耐心等待退款!");
    },
    /**
     * 查看物流
     * @param {*} company
     * @param {*} express_no
     */
    async getExpressInfo(company, express_no) {
      const { data } = await this.$axios.get(
        this.$apiBaseUrl +
        "/api/628b4e8f06e3d?company=" +
        company +
        "&express_no=" +
        express_no,
      );
      this.shipData = data.data;
      this.dialogShipVisable = true;
    },
  },
};
</script>

<style scoped>
.ucenter {
  background-color: #f5f7fa;
  min-height: 100vh;
  padding: 20px;
  width: 100%;
  overflow-x: hidden;
}

/* 左侧菜单样式 */
.ucenter-sider {
  padding-right: 10px;
}

.sidebar-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  height: 100%;
}

.sidebar-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #ff6b6b;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ucenter-sider .el-collapse {
  border: none;
}

.ucenter-sider .collapse-item__title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ucenter-sider .collapse-item__ul {
  padding: 10px 0 0 0;
}

.ucenter-sider .collapse-item__ul li {
  color: #757578;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  padding-left: 1em;
  cursor: pointer;
  border-radius: 6px;
  margin: 4px 0;
  transition: all 0.3s ease;
}

.ucenter-sider .collapse-item__ul li:hover {
  background-color: #f8f9fa;
  color: #ff6b6b;
  padding-left: 1.5em;
}

.ucenter-sider .collapse-item__ul .active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white !important;
  padding-left: 1.5em;
}

/* 右侧内容区 */
.ucenter-content {
  padding-left: 10px;
}

.content-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
}

/* 筛选区域 */
.filter-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  width: 96%;
}

.filter-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.filter-section .section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-form .el-form-item {
  margin-bottom: 15px;
}

.search-button {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  border: none;
  padding: 10px 24px;
}

.search-button:hover {
  background: linear-gradient(135deg, #ee5a5a 0%, #ff6b6b 100%);
}

.export-button {
  background: linear-gradient(135deg, #67c23a 0%, #5daf34 100%);
  border: none;
  padding: 10px 24px;
}

.export-button:hover {
  background: linear-gradient(135deg, #5daf34 0%, #67c23a 100%);
}

/* 快捷查询 */
.quick-filter-section {
  background: white;
  border-radius: 12px;
  padding: 15px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  width: 96%;
}

.quick-filter-section .custom-tabs>>>.el-tabs__header {
  margin-bottom: 0;
}

.quick-filter-section .custom-tabs>>>.el-tabs__nav {
  border: none;
}

.quick-filter-section .custom-tabs>>>.el-tabs__item {
  border-radius: 6px;
  margin-right: 10px;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}

.quick-filter-section .custom-tabs>>>.el-tabs__item.is-active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
  border-color: #ff6b6b;
}

.quick-filter-section .custom-tabs>>>.el-tabs__item:hover {
  color: #ff6b6b;
}

.quick-filter-section .custom-tabs>>>.el-tabs__item.is-active:hover {
  color: white;
}

/* 订单列表区域 */
.order-list-section {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  width: 96%;
}

.order-list-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
}

.order-list-section .section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;
}

.batch-actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.batch-btn {
  padding: 8px 16px;
}

/* 表格样式 */
.order-table {
  width: 100% !important;
}

.order-table ::v-deep .el-table__header th {
  background: #e9ecef !important;
  background-color: #e9ecef !important;
  height: 28px !important;
  padding: 0 !important;
}

.order-table ::v-deep .el-table__header .cell {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  padding: 4px 10px !important;
}

.order-table ::v-deep .el-table__body {
  width: 100% !important;
}

.order-table ::v-deep .el-table__row {
  height: auto !important;
}

.order-table ::v-deep .el-table__row td {
  height: auto !important;
  padding: 5px 0 !important;
}

.order-table ::v-deep .cell {
  padding: 0 10px !important;
  white-space: normal !important;
  overflow: visible !important;
}

/* 商品单元格布局 */
.goods-cell {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  text-align: left;
}

/* 操作链接容器 */
.action-links {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 5px 0;
}

.action-links .el-link {
  display: block;
  font-size: 12px;
  line-height: 20px;
}

/* 订单信息头部 */
.order-info {
  width: 100%;
  background: linear-gradient(135deg, #fff8f0 0%, #fff1e8 100%);
  margin-top: 15px;
  display: flex;
  flex-direction: row;
  font-size: 13px;
  line-height: 40px;
  height: 40px;
  padding: 0 15px;
  border-radius: 8px 8px 0 0;
  border: 1px solid #ffe4d0;
  border-bottom: none;
}

.order-info-main {
  padding: 0;
  display: flex;
  align-items: center;
}

.order-info-user {
  text-align: right;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.order-info-main span,
.order-info-user span {
  font-size: 13px;
  color: #3d3d40;
}

/* 订单商品 */
.order-goods {
  display: flex;
  flex-direction: row;
  padding: 5px 0;
}

.goods-image .el-image {
  width: 60px;
  height: 60px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.goods-info {
  font-size: 12px;
  text-decoration: none;
  margin-left: 15px;
}

.goods-info div {
  line-height: 20px;
  height: 20px;
}

.goods-info .goods-info-name {
  white-space: nowrap;
  overflow: hidden;
  max-width: 140px;
  text-overflow: ellipsis;
  font-weight: 500;
  color: #333;
}

.goods-info .goods-info-no {
  text-align: left;
  color: #666;
}

.goods-info .goods-info-price {
  text-align: left;
  color: #ff6b6b;
  font-weight: 600;
}

.goods-info-no span,
.goods-info-price span {
  color: #333;
}

.goods-spec {
  width: 100%;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  min-height: 30px;
  color: #666;
}

.order-total-money {
  font-size: 12px;
  width: 100%;
  text-align: center;
  color: #ff6b6b;
}

.order-total-money div {
  line-height: 18px;
  height: 18px;
}

.order-status {
  font-size: 12px;
  width: 100%;
  text-align: center;
}

.order-status .status-text {
  display: inline-block;
  line-height: 20px;
  font-weight: 500;
  color: #ff6b6b;
}

.order-express {
  height: 40px;
  line-height: 40px;
  font-size: 13px;
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-top: none;
  border-radius: 0 0 8px 8px;
  padding: 0 15px;
  margin-bottom: 15px;
}

.order-express .goods-num {
  color: #ff6b6b;
  text-align: right;
  padding-right: 20px;
  font-weight: 600;
}

.order-action {
  display: block;
  font-size: 12px;
  line-height: 22px;
  color: #1890ff;
  transition: all 0.3s ease;
}

.order-action:hover {
  color: #ff6b6b;
  cursor: pointer;
}

/* 分页 */
.pagination-container {
  text-align: center;
  margin-top: 30px;
}

.pagination-container>>>.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
}

.pagination-container>>>.el-pagination.is-background .btn-next,
.pagination-container>>>.el-pagination.is-background .btn-prev,
.pagination-container>>>.el-pagination.is-background .el-pager li {
  background: #f8f9fa;
  border-radius: 6px;
  margin: 0 5px;
}

.pagination-container>>>.el-pagination.is-background .btn-next:hover,
.pagination-container>>>.el-pagination.is-background .btn-prev:hover,
.pagination-container>>>.el-pagination.is-background .el-pager li:hover {
  color: #ff6b6b;
}

/* 弹窗样式 */
#refund-dialog {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #e9e9e9;
}

/* Element UI 组件样式覆盖 */
.ucenter>>>.el-input__inner {
  border-radius: 6px;
  border: 1px solid #e0e0e0;
}

.ucenter>>>.el-input__inner:focus {
  border-color: #ff6b6b;
}

.ucenter>>>.el-select .el-input__inner {
  border-radius: 6px;
}

.ucenter>>>.el-date-editor.el-input {
  width: 100%;
}
</style>
